var recharge_lable_changed = false;
$(document).ready(function(){
  inject_product_data();

  try {
    Fancybox.bind(".emf_vimeo a", {
      // Your options go here
    });
    Fancybox.bind('#section_benefits a[href*="vimeo.com"]', {
      // Your options go here
    });
	Fancybox.bind('.accordion.product_det_acord .expanded__content a[href*="youtube.com"]', {
		// Your options go here
	  });
  }
  catch(err) {
    
  }
  setTimeout(function() {
    console.log("cld");
	render_related_slider();
    if($('.product-form .rc_widget__option__label span.rc_widget__option__discount').length > 0 && !recharge_lable_changed){
      update_subscription_widget();
    }
    
  }, 1050);
  setTimeout(function() {
    console.log("cld2");
    if($('.product-form .rc_widget__option__label span.rc_widget__option__discount').length > 0 && !recharge_lable_changed){
      update_subscription_widget();
    }
    
  }, 1850);

  setTimeout(function() {
    console.log("cld3");
    if($('.product-form .rc_widget__option__label span.rc_widget__option__discount').length > 0 && !recharge_lable_changed){
      update_subscription_widget();
    }
    
  }, 2750);
  function update_subscription_widget(){
    recharge_lable_changed = true;
      $('.product-form .rc_widget__option__label span.rc_widget__option__discount').prepend('Save ');
      //$('.rc_widget__option--subsave .rc_widget__option__selector').append('<p class="rsub_det">Let us deliver your products on your schedule! We make it easy for you to make changes to your account, adjust delivery, or cancel anytime.</p> ')

  }
  $("ul#qty_lister").on("click", ".init", function() {
    //console.log("clk");
    $(this).closest("ul").toggleClass("opened");
    //$(this).closest("ul").children('li:not(.init)').toggle();
});

var allOptions = $("ul#qty_lister").children('li:not(.init)');
$("ul#qty_lister").on("click", "li:not(.init)", function() {
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $("ul#qty_lister").children('.init').html('Qty: '+$(this).html());
    jQuery('input[name="quantity"]').val($(this).data('value'));
    //allOptions.toggle();
    $(this).closest("ul").toggleClass("opened");
});
  
});

function inject_product_data(){
  var pd_id = jQuery('#pdata_id').val();
  console.log(pd_id);
  if(isNaN(pd_id) || pd_id < 1){
    console.log("invalid pdid "+pd_id);
    return false;
  }
  $.ajax({
    type: 'GET',
    //data: data,
    url: 'https://innovativemedicine.com/wp-json/wp/v2/productsdata?include[]='+pd_id,
    dataType: 'json',
    success: function(response) {
      console.log(response.length);
      if(response.length > 0){
        var pd_data = response[0];
        $('#shopify-section-product-data > div').html(pd_data.content.rendered);
        if(jQuery('#shopify-section-product-data .section_faq_holder').length > 0)
        {
          jQuery('.togglecontainer', 'body').avia_sc_toggle();
		  if(jQuery('.togglecontainer .av_toggle_section').length > 5){
			jQuery('.togglecontainer .av_toggle_section:nth-child(n+5)').hide();
			jQuery('.togglecontainer').append('<a class="faq_show_all" href="#">Load More </a>')
		  }

        }
        try {
          Fancybox.bind(".emf_vimeo a", {
            // Your options go here
          });
          Fancybox.bind('#section_benefits a[href*="vimeo.com"]', {
            // Your options go here
          });
        }
        catch(err) {
          
        }
        

      }
      
    }
  });
}

(function($)
{ 
	"use strict";
	
	$.fn.avia_sc_toggle = function(options)
	{
		var defaults =
		{
			single: '.single_toggle',
			heading: '.toggler',
			content: '.toggle_wrap',
			sortContainer:'.taglist'
		};
	
		var win = $(window),
			options = $.extend(defaults, options);
	
		return this.each(function()
		{
			var container 	= $(this).addClass('enable_toggles'),
				toggles		= $(options.single, container),
				heading 	= $(options.heading, container),
				activeStyle = $(container).attr('data-currentstyle'),
				allContent 	= $(options.content, container),
				sortLinks	= $(options.sortContainer + " a", container);


			heading.each(function(i)
			{
				var thisheading =  $(this),
					content = thisheading.next(options.content, container),
					headingStyle = thisheading.attr('style'),
                    hoverStyle = thisheading.data( 'hoverstyle' );
					
				if( 'undefined' == typeof headingStyle )
				{
					headingStyle = '';
				}
				
				if( 'undefined' == typeof hoverStyle )
				{
					hoverStyle = '';
				}

				function scroll_to_viewport()
				{
          console.log("scrol to vp11")
				    //check if toggle title is in viewport. if not scroll up
				    var el_offset = content.offset().top,
				        scoll_target = el_offset - 50 - parseInt($('html').css('margin-top'),10);
                console.log(scoll_target);
	
				    if(win.scrollTop() > el_offset)
				    {
				        $('html:not(:animated),body:not(:animated)').animate({scrollTop: scoll_target},200);
				    }
				}
	
				if(content.css('visibility') != "hidden")
				{
					thisheading.addClass('activeTitle').attr('style',activeStyle);
				}
	
				thisheading.on('keydown', function(objEvent)
				{
					if (objEvent.keyCode === 13) { // if user presses 'enter'
								thisheading.trigger('click');
							}
				});
				
				thisheading.on( 'click', function()
				{
					if(content.css('visibility') != "hidden")
					{
						content.slideUp(200, function()
						{
							content.removeClass('active_tc').attr({style:''});
							win.trigger('av-height-change');
							win.trigger('av-content-el-height-changed', this );
							
							location.replace(thisheading.data('fake-id') + "-closed");
						});
						
						thisheading.removeClass('activeTitle').attr('style',headingStyle);

					}
					else
					{
						if(container.is('.toggle_close_all'))
						{
							allContent.not(content).slideUp(200, function()
							{
								$(this).removeClass('active_tc').attr({style:''});
								scroll_to_viewport();
							});
							heading.removeClass('activeTitle').attr('style',headingStyle);
						}
						
						content.addClass('active_tc');
						
						setTimeout(function(){
							
							content.slideDown(200,
							
								function()
								{
			                        if(!container.is('.toggle_close_all'))
			                        {
			                            scroll_to_viewport();
			                        }
			                        
			                        win.trigger('av-height-change');
									win.trigger('av-content-el-height-changed', this );
								}
							
							);
						
						}, 1);
						
						thisheading.addClass('activeTitle').attr('style',activeStyle);
						location.replace(thisheading.data('fake-id'));
					}

				});

				/* change style on hover */
				if( hoverStyle ) 
				{
                    thisheading.on('mouseenter', function() {
                            if ( ! thisheading.hasClass('activeTitle') ) 
							{
                                $(this).attr( 'style', hoverStyle );
							}
                        }).on('mouseleave', function() {
                            if ( ! thisheading.hasClass('activeTitle') ) 
							{
								$(this).attr( 'style', headingStyle );
                            }
                        }
                    );
				}

            });
	
	
			sortLinks.on( 'click', function(e){
	
										e.preventDefault();
										var show = toggles.filter('[data-tags~="'+$(this).data('tag')+'"]'),
											hide = toggles.not('[data-tags~="'+$(this).data('tag')+'"]');

											sortLinks.removeClass('activeFilter');
											$(this).addClass('activeFilter');
											heading.filter('.activeTitle').trigger('click');
											show.slideDown();
											hide.slideUp();
									});
	
	
			function trigger_default_open(hash)
			{
				if(!hash && window.location.hash) hash = window.location.hash;
				if(!hash) return;
				
				var open = heading.filter('[data-fake-id="'+hash+'"]');
	
				if(open.length)
				{
					if(!open.is('.activeTitle')) open.trigger('click');
					window.scrollTo(0, container.offset().top - 70);
				}
			}
			trigger_default_open(false);
			
			$('a').on( 'click',function(){
	            var hash = $(this).attr('href');
	            if(typeof hash != "undefined" && hash)
	            {
	                hash = hash.replace(/^.*?#/,'');
	                trigger_default_open('#'+hash);
	            }
	        });
	
		});
	};
	
}(jQuery));

jQuery('body').on('click', '.faq_show_all', function(e) {
	el = $(this);
	e.preventDefault();
	jQuery('.togglecontainer .av_toggle_section:nth-child(n+5)').show();
	el.remove();
});

function render_related_slider(){

		if(jQuery('.maybe_slick').length > 0){
		  //console.log("fire slick");
		  jQuery('.maybe_slick').show();
		  jQuery('.maybe_slick').slick({
			dots: true,
			infinite: false,
			autoplay: true,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 1,
			prevArrow:'<button type="button" class="slick-prev-custom"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><rect x="-0.5" y="0.5" width="33" height="33" rx="16.5" transform="matrix(-1 0 0 1 33 0)" stroke="#1C1C1C"></rect><path d="M25.5 16.9995L10.0456 16.9995" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path><path d="M15.5793 9.92041L8.49993 16.9998L15.5793 24.0792" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path></svg></button>',
			nextArrow:'<button type="button" class="slick-next-custom"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#1C1C1C"></rect><path d="M8.5 16.9995L23.9544 16.9995" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path><path d="M18.4207 9.92041L25.5001 16.9998L18.4207 24.0792" stroke="#1C1C1C" stroke-width="1.5" stroke-linecap="square"></path></svg></button>',
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
				  }
				}
			  ]
		   
		  });
		
		}
	 
}